import React from 'react';

import { getFormattedTimeWindow, LayoutType } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import { formatUtilizationPercent } from 'bringg-web/features/delivery-blocks-v2/utils/delivery-block-utilization';

import './summary-details.scss';

export type SummaryDetailsUtilization = {
	ordersCount: number;
	utilizationPercent?: number | null;
};

interface Props {
	name: string;
	blockTime: { startTime: string | null; endTime: string | null };
	resources: { connectedResources: number | undefined; maxResources: number | undefined };
	hourFormat: string;
	timezone: string;
	utilization?: SummaryDetailsUtilization;
}
export const SummaryDetails = observer(({ name, resources, blockTime, hourFormat, timezone, utilization }: Props) => {
	const { t } = useTranslation();
	const { connectedResources, maxResources } = resources || {};
	const { startTime, endTime } = blockTime || {};
	const resourcesLabel = `${t('DELIVERY_BLOCK_MODAL.RESOURCES')}: ${connectedResources || '0'}/${
		maxResources || '0'
	}`;

	return (
		<div className="delivery-block-summary-details">
			<span className="summary-details-title">{t('DELIVERY_BLOCK_MODAL.SUMMARY')}</span>
			<span className="summary-details-name">{name}</span>
			{startTime && endTime && (
				<span className="summary-details-block-time">
					{getFormattedTimeWindow(
						blockTime.startTime,
						blockTime.endTime,
						hourFormat,
						timezone,
						LayoutType.INLINE,
						''
					)}
				</span>
			)}
			{utilization ? (
				<span className="summary-details-chips" data-test-id="summary-details-utilization">
					<span className="summary-details-chip summary-details-resources">
						<BringgIcon iconName={BringgFontIcons.Resources} />
						{resourcesLabel}
					</span>
					<span className="summary-details-chip" data-test-id="summary-details-orders-chip">
						<BringgIcon iconName={BringgFontIcons.Orders} />
						{`${t('DELIVERY_BLOCKS.UTILIZATION.ORDERS')}: ${utilization.ordersCount}`}
					</span>
					{utilization.utilizationPercent != null && (
						<span className="summary-details-chip" data-test-id="summary-details-utilized-chip">
							{`${formatUtilizationPercent(utilization.utilizationPercent)} ${t(
								'DELIVERY_BLOCKS.UTILIZATION.UTILIZED'
							)}`}
						</span>
					)}
				</span>
			) : (
				<span className="summary-details-resources">{resourcesLabel}</span>
			)}
		</div>
	);
});
